// extracted by mini-css-extract-plugin
export default {"heading":"Placeholder_heading__dZmhl"};